module.exports = __webpack_public_path__ + "static/a806d95bb75ff3be6e41e3334df2d9dbc1b858c5fe652630a5b4adc4c54e3147-7f25bae56c3ea3d69ceb3fa3b9a74651.png";